/**
 * LA CARA DE UN INDICADOR DE LA CASA EN LA SALA (#/salud): el numero grande y la frase "X de Y".
 *
 * Salio de SaludView.js para poder probarla sola (REUSAMOS-INDICADOR-T1, dictamen de Q #28069 sobre nexo-api 538).
 * Con el 538, 2_reusamos.pct pasa a ser la reutilizacion VERIFICADA y su "de cuantos" vive en
 * reuso_verificado { cumple, de }; las claves de primer nivel tareas_creadas_semana y con_reuso_declarado se van
 * (el numero viejo queda en busqueda_hecha). Esta funcion lee la forma NUEVA y, si no viene, la de antes: sirve
 * antes y despues del 538, sin carrera de despliegues.
 *
 * Sin DOM.
 * @module application/salud/caraDelIndicador
 */

const nfmt = (n) => (n === null || n === undefined || Number.isNaN(n) ? '—' : Number(n).toLocaleString('es-CO'));

export function caraDelIndicador(i) {
  const n = (i && i.numeros) || {};
  if (typeof n.pct === 'number') {
    // 2_reusamos desde el 538: reuso_verificado { cumple, de }. Antes: tareas_creadas_semana / con_reuso_declarado.
    // 1_nos_conocemos: objetos / en_mapa.
    const rv = n.reuso_verificado && typeof n.reuso_verificado === 'object' ? n.reuso_verificado : null;
    const de = rv?.de ?? n.objetos ?? n.tareas_creadas_semana;
    const parte = rv?.cumple ?? n.en_mapa ?? n.con_reuso_declarado;
    return { grande: n.pct + '%', frase: de ? nfmt(parte) + ' de ' + nfmt(de) + (rv ? ' verificadas' : '') : '' };
  }
  if (typeof n.saldo_hoy === 'number') {
    return { grande: (n.saldo_hoy > 0 ? '+' : '') + n.saldo_hoy,
      frase: 'cerradas ' + nfmt(n.tareas_cerradas_hoy) + ', abiertas ' + nfmt(n.tareas_creadas_hoy) };
  }
  if (typeof n.prs_abiertos === 'number') {
    return { grande: String(n.prs_abiertos), frase: nfmt(n.sin_dictamen) + ' sin revisar' };
  }
  if (typeof n.repeticiones_de_regla_existente === 'number') {
    return { grande: String(n.repeticiones_de_regla_existente),
      frase: 'errores repetidos, de ' + nfmt(n.correcciones_semana) + ' correcciones' };
  }
  if (typeof n.con_ficha_viva === 'number') {
    return { grande: nfmt(n.con_ficha_viva) + ' de ' + nfmt(n.colaboradores_activos),
      frase: 'con su ficha viva' };
  }
  const primero = Object.entries(n).find(([, v]) => typeof v === 'number');
  return { grande: primero ? String(primero[1]) : '—', frase: '' };
}
